const ToastStatusEnum = {
  Error: "error",
  Warning: "warning",
  Success: "success",
};

export default ToastStatusEnum;
